(() => {

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire503e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire503e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("g5O3G", function(module, exports) {
/*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */ "use strict";

var $ab1nR = parcelRequire("ab1nR");

var $fHenM = parcelRequire("fHenM");

var $4ntVg = parcelRequire("4ntVg");

var $hGGZK = parcelRequire("hGGZK");
function $bb73f18d00d8f5c5$var$peg$subclass(child, parent) {
    function ctor() {
        this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
}
function $bb73f18d00d8f5c5$var$peg$SyntaxError(message, expected, found, location) {
    this.message = message;
    this.expected = expected;
    this.found = found;
    this.location = location;
    this.name = "SyntaxError";
    if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $bb73f18d00d8f5c5$var$peg$SyntaxError);
}
$bb73f18d00d8f5c5$var$peg$subclass($bb73f18d00d8f5c5$var$peg$SyntaxError, Error);
$bb73f18d00d8f5c5$var$peg$SyntaxError.buildMessage = function(expected, found) {
    var DESCRIBE_EXPECTATION_FNS = {
        literal: function(expectation) {
            return "\"" + literalEscape(expectation.text) + "\"";
        },
        "class": function(expectation) {
            var escapedParts = "", i;
            for(i = 0; i < expectation.parts.length; i++)escapedParts += expectation.parts[i] instanceof Array ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1]) : classEscape(expectation.parts[i]);
            return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
        },
        any: function(expectation) {
            return "any character";
        },
        end: function(expectation) {
            return "end of input";
        },
        other: function(expectation) {
            return expectation.description;
        }
    };
    function hex(ch) {
        return ch.charCodeAt(0).toString(16).toUpperCase();
    }
    function literalEscape(s) {
        return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function(ch) {
            return '\\x0' + hex(ch);
        }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
            return '\\x' + hex(ch);
        });
    }
    function classEscape(s) {
        return s.replace(/\\/g, '\\\\').replace(/\]/g, '\\]').replace(/\^/g, '\\^').replace(/-/g, '\\-').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function(ch) {
            return '\\x0' + hex(ch);
        }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
            return '\\x' + hex(ch);
        });
    }
    function describeExpectation(expectation) {
        return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
    }
    function describeExpected(expected) {
        var descriptions = new Array(expected.length), i, j;
        for(i = 0; i < expected.length; i++)descriptions[i] = describeExpectation(expected[i]);
        descriptions.sort();
        if (descriptions.length > 0) {
            for(i = 1, j = 1; i < descriptions.length; i++)if (descriptions[i - 1] !== descriptions[i]) {
                descriptions[j] = descriptions[i];
                j++;
            }
            descriptions.length = j;
        }
        switch(descriptions.length){
            case 1:
                return descriptions[0];
            case 2:
                return descriptions[0] + " or " + descriptions[1];
            default:
                return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
        }
    }
    function describeFound(found) {
        return found ? "\"" + literalEscape(found) + "\"" : "end of input";
    }
    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};
function $bb73f18d00d8f5c5$var$peg$parse(input, options) {
    options = options !== void 0 ? options : {};
    var peg$FAILED = {}, peg$startRuleFunctions = {
        Expression: peg$parseExpression
    }, peg$startRuleFunction = peg$parseExpression, peg$c0 = peg$otherExpectation("expression"), peg$c1 = function(expr) {
        return expr;
    }, peg$c2 = "=", peg$c3 = peg$literalExpectation("=", false), peg$c4 = "\\", peg$c5 = peg$literalExpectation("\\", false), peg$c6 = function(head, a) {
        return a;
    }, peg$c7 = function(head, tail) {
        return tail.reduce(function(result, element) {
            return createNode("operator", [
                result,
                element[3]
            ], {
                name: element[1],
                operatorType: 'infix'
            });
        }, head);
    }, peg$c8 = function(w) {
        return check(w, texOperators1);
    }, peg$c9 = function(w) {
        return w;
    }, peg$c10 = function(w) {
        return check(w, texPrefixOperators1);
    }, peg$c11 = "+", peg$c12 = peg$literalExpectation("+", false), peg$c13 = "-", peg$c14 = peg$literalExpectation("-", false), peg$c15 = "*", peg$c16 = peg$literalExpectation("*", false), peg$c17 = "/", peg$c18 = peg$literalExpectation("/", false), peg$c19 = "\\cdot", peg$c20 = peg$literalExpectation("\\cdot", false), peg$c21 = function(head) {
        return "cdot";
    }, peg$c22 = function(name) {
        return name;
    }, peg$c23 = function(sign, operand) {
        return createNode("operator", [
            operand
        ], {
            name: sign,
            operatorType: 'prefix'
        });
    }, peg$c24 = function(head, tail) {
        return tail.reduce(function(result, element) {
            return createNode("automult", [
                result,
                element[1]
            ]);
        }, head);
    }, peg$c25 = "!", peg$c26 = peg$literalExpectation("!", false), peg$c27 = function(base, exp, fac) {
        if (exp) base = new $ab1nR("operator", [
            base,
            exp
        ], {
            name: '^',
            operatorType: 'infix'
        });
        if (fac) base = new $ab1nR("operator", [
            base
        ], {
            name: '!',
            operatorType: 'postfix'
        });
        return base;
    }, peg$c28 = "\\big", peg$c29 = peg$literalExpectation("\\big", false), peg$c30 = "\\Big", peg$c31 = peg$literalExpectation("\\Big", false), peg$c32 = "\\bigg", peg$c33 = peg$literalExpectation("\\bigg", false), peg$c34 = "\\Bigg", peg$c35 = peg$literalExpectation("\\Bigg", false), peg$c36 = "\\left", peg$c37 = peg$literalExpectation("\\left", false), peg$c38 = "|", peg$c39 = peg$literalExpectation("|", false), peg$c40 = "\\right", peg$c41 = peg$literalExpectation("\\right", false), peg$c42 = function(e) {
        return createNode("abs", [
            e
        ]);
    }, peg$c43 = peg$otherExpectation("functions"), peg$c44 = peg$otherExpectation("builtin functions"), peg$c45 = function(name, exp, args) {
        if (!Array.isArray(args)) args = [
            args
        ];
        let func = new $ab1nR('function', args, {
            name: name,
            isBuiltin: true
        });
        if (!exp) return func;
        else return createNode("operator", [
            func,
            exp
        ], {
            name: '^',
            operatorType: 'infix'
        });
    }, peg$c46 = function(name) {
        return check(name, options.builtinFunctions);
    }, peg$c47 = function(name) {
        return name;
    }, peg$c48 = "\\operatorname", peg$c49 = peg$literalExpectation("\\operatorname", false), peg$c50 = "{", peg$c51 = peg$literalExpectation("{", false), peg$c52 = "}", peg$c53 = peg$literalExpectation("}", false), peg$c54 = function(name, args) {
        return createNode("operatorname", args, {
            name: name
        });
    }, peg$c55 = function(name) {
        return check(name, options.functions);
    }, peg$c56 = function(name, args) {
        return createNode('function', args, {
            name: name
        });
    }, peg$c57 = function() {
        doesContainEllipsis.push(false);
        return true;
    }, peg$c58 = "(", peg$c59 = peg$literalExpectation("(", false), peg$c60 = ")", peg$c61 = peg$literalExpectation(")", false), peg$c62 = function(a) {
        let __doesContainEllipsis = doesContainEllipsis.pop();
        let ellipsis = options.extra.ellipsis;
        let ellipsisAllowed = typeof ellipsis === 'object' ? ellipsis.funcArgs : ellipsis;
        if (__doesContainEllipsis && !ellipsisAllowed) error('ellipsis is not allowed to be an arg in a function');
        return Array.isArray(a) ? a : [
            a
        ];
    }, peg$c63 = function() {
        doesContainEllipsis.pop();
        return true;
    }, peg$c64 = function() {
        return [];
    }, peg$c65 = ",", peg$c66 = peg$literalExpectation(",", false), peg$c67 = function(head, tail) {
        if (tail.length) {
            tail.unshift(head);
            return tail;
        }
        if (head.type === 'ellipsis') error("can't use ellipsis as a stand-alone expression");
        return head;
    }, peg$c68 = "...", peg$c69 = peg$literalExpectation("...", false), peg$c70 = function(t) {
        return t;
    }, peg$c71 = function(type) {
        return createNode("ellipsis", null, {
            type: type
        });
    }, peg$c72 = "dots", peg$c73 = peg$literalExpectation("dots", false), peg$c74 = "cdots", peg$c75 = peg$literalExpectation("cdots", false), peg$c76 = "vdots", peg$c77 = peg$literalExpectation("vdots", false), peg$c78 = "ddots", peg$c79 = peg$literalExpectation("ddots", false), peg$c80 = function(e) {
        doesContainEllipsis[doesContainEllipsis.length - 1] = true;
        return e;
    }, peg$c81 = function(o) {
        doesContainEllipsis.push(false);
        return true;
    }, peg$c82 = function(o, arr1dOrExpr, c) {
        return handleBlock(arr1dOrExpr, o, c);
    }, peg$c83 = function() {
        doesContainEllipsis.pop();
        return false;
    }, peg$c84 = "a", peg$c85 = peg$literalExpectation("a", false), peg$c86 = "[", peg$c87 = peg$literalExpectation("[", false), peg$c88 = "\\{{", peg$c89 = peg$literalExpectation("\\{{", false), peg$c90 = "\\{", peg$c91 = peg$literalExpectation("\\{", false), peg$c92 = function(a) {
        return a.length > 1 ? a[1] : a;
    }, peg$c93 = "]", peg$c94 = peg$literalExpectation("]", false), peg$c95 = "\\}}", peg$c96 = peg$literalExpectation("\\}}", false), peg$c97 = "\\}", peg$c98 = peg$literalExpectation("\\}", false), peg$c99 = function(name) {
        return createNode('id', null, {
            name: name,
            isBuiltin: true
        });
    }, peg$c100 = function(name) {
        return !check(name, [
            "begin",
            "end",
            "right" /* for rightPrefixes */ ,
            "cdot",
            "operatorname"
        ]);
    }, peg$c101 = function(name) {
        if (check(name, options.builtinLetters)) return name;
        if (check(name, [
            options.builtinFunctions,
            options.functions,
            [
                'sqrt',
                'int',
                'sum',
                'prod'
            ]
        ])) error(`"${name}" is used with no arguments arguments! it can't be used as variable!`);
        error('undefined control sequence "' + name + '"');
    }, peg$c102 = "\\sqrt", peg$c103 = peg$literalExpectation("\\sqrt", false), peg$c104 = function(exp, arg) {
        // exp = exp || createNode("number", null, {value:2});
        return exp ? createNode("sqrt", [
            arg,
            exp
        ]) : createNode("sqrt", [
            arg
        ]);
    }, peg$c105 = "int", peg$c106 = peg$literalExpectation("int", false), peg$c107 = "sum", peg$c108 = peg$literalExpectation("sum", false), peg$c109 = "prod", peg$c110 = peg$literalExpectation("prod", false), peg$c111 = "_", peg$c112 = peg$literalExpectation("_", false), peg$c113 = function(n, sub, sup) {
        return [
            sub,
            sup
        ];
    }, peg$c114 = function(n, sup, sub) {
        return [
            sub,
            sup
        ];
    }, peg$c115 = function(n, subsup, arg) {
        subsup.push(arg);
        return createNode(n, subsup);
    }, peg$c116 = "\\frac", peg$c117 = peg$literalExpectation("\\frac", false), peg$c118 = function(first, second) {
        return [
            first,
            second
        ];
    }, peg$c119 = function(args) {
        return createNode("frac", args);
    }, peg$c120 = peg$otherExpectation("digit or char"), peg$c121 = function() {
        let txt = text();
        if (isNaN(txt)) return createNode("id", null, {
            name: txt
        });
        else return createNode("number", null, {
            value: parseFloat(txt)
        });
    }, peg$c122 = "\\begin", peg$c123 = peg$literalExpectation("\\begin", false), peg$c124 = "\\end", peg$c125 = peg$literalExpectation("\\end", false), peg$c126 = function(t1, rows, t2) {
        if (t1 !== t2) error(`different titles: \\begin{${t1}} and \\end{${t2}}`);
        if (!check(t1, [
            "matrix",
            "pmatrix",
            "bmatrix",
            "Bmatrix",
            "smallmatrix",
            "Bmatrix",
            "vmatrix",
            "Vmatrix"
        ])) error(`invalid matrix type: ${t1}`);
        return createNode("matrix", rows, {
            matrixType: t1
        });
    }, peg$c127 = "\\\\", peg$c128 = peg$literalExpectation("\\\\", false), peg$c129 = function(head, tail) {
        tail = tail.map((n)=>n[3]);
        tail.unshift(head);
        return tail;
    }, peg$c130 = "&", peg$c131 = peg$literalExpectation("&", false), peg$c132 = ".", peg$c133 = peg$literalExpectation(".", false), peg$c134 = function(head, tail) {
        // reduce from left to right, ltr
        return tail.reduce(function(result, element) {
            return createNode("member expression", [
                result,
                element[3]
            ]);
        }, head);
    }, peg$c135 = peg$otherExpectation("name"), peg$c136 = function(name, sub) {
        let n = createNode('id', null, {
            name: name
        });
        if (sub) n.sub = sub;
        return n;
    }, peg$c137 = function(w) {
        return createNode("id", null, {
            name: w
        });
    }, peg$c138 = function(n) {
        return n;
    }, peg$c139 = peg$otherExpectation("letter or number"), peg$c140 = /^[a-zA-Z0-9]/, peg$c141 = peg$classExpectation([
        [
            "a",
            "z"
        ],
        [
            "A",
            "Z"
        ],
        [
            "0",
            "9"
        ]
    ], false, false), peg$c142 = peg$otherExpectation("letter"), peg$c143 = /^[a-zA-Z]/, peg$c144 = peg$classExpectation([
        [
            "a",
            "z"
        ],
        [
            "A",
            "Z"
        ]
    ], false, false), peg$c145 = function() {
        return text();
    }, peg$c146 = peg$otherExpectation("number"), peg$c147 = function(sign) {
        let value = parseFloat(text().replace(/[ \t\n\r]/g, ''));
        return createNode('number', null, {
            value: value
        });
    }, peg$c148 = /^[0-9]/, peg$c149 = peg$classExpectation([
        [
            "0",
            "9"
        ]
    ], false, false), peg$c150 = peg$otherExpectation("superscript"), peg$c151 = "^", peg$c152 = peg$literalExpectation("^", false), peg$c153 = function(arg) {
        return arg;
    }, peg$c154 = peg$otherExpectation("subscript"), peg$c155 = peg$otherExpectation("function argument"), peg$c156 = peg$otherExpectation("newline"), peg$c157 = "\n", peg$c158 = peg$literalExpectation("\n", false), peg$c159 = "\r\n", peg$c160 = peg$literalExpectation("\r\n", false), peg$c161 = peg$otherExpectation("space or tab"), peg$c162 = " ", peg$c163 = peg$literalExpectation(" ", false), peg$c164 = "\t", peg$c165 = peg$literalExpectation("\t", false), peg$c166 = "\\ ", peg$c167 = peg$literalExpectation("\\ ", false), peg$c168 = peg$otherExpectation("whitespace"), peg$c169 = peg$otherExpectation("optional whitespace"), peg$currPos = 0, peg$savedPos = 0, peg$posDetailsCache = [
        {
            line: 1,
            column: 1
        }
    ], peg$maxFailPos = 0, peg$maxFailExpected = [], peg$silentFails = 0, peg$result;
    if ("startRule" in options) {
        if (!(options.startRule in peg$startRuleFunctions)) throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
        peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }
    function text() {
        return input.substring(peg$savedPos, peg$currPos);
    }
    function location() {
        return peg$computeLocation(peg$savedPos, peg$currPos);
    }
    function expected(description, location) {
        location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
        throw peg$buildStructuredError([
            peg$otherExpectation(description)
        ], input.substring(peg$savedPos, peg$currPos), location);
    }
    function error(message, location) {
        location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
        throw peg$buildSimpleError(message, location);
    }
    function peg$literalExpectation(text, ignoreCase) {
        return {
            type: "literal",
            text: text,
            ignoreCase: ignoreCase
        };
    }
    function peg$classExpectation(parts, inverted, ignoreCase) {
        return {
            type: "class",
            parts: parts,
            inverted: inverted,
            ignoreCase: ignoreCase
        };
    }
    function peg$anyExpectation() {
        return {
            type: "any"
        };
    }
    function peg$endExpectation() {
        return {
            type: "end"
        };
    }
    function peg$otherExpectation(description) {
        return {
            type: "other",
            description: description
        };
    }
    function peg$computePosDetails(pos) {
        var details = peg$posDetailsCache[pos], p;
        if (details) return details;
        else {
            p = pos - 1;
            while(!peg$posDetailsCache[p])p--;
            details = peg$posDetailsCache[p];
            details = {
                line: details.line,
                column: details.column
            };
            while(p < pos){
                if (input.charCodeAt(p) === 10) {
                    details.line++;
                    details.column = 1;
                } else details.column++;
                p++;
            }
            peg$posDetailsCache[pos] = details;
            return details;
        }
    }
    function peg$computeLocation(startPos, endPos) {
        var startPosDetails = peg$computePosDetails(startPos), endPosDetails = peg$computePosDetails(endPos);
        return {
            start: {
                offset: startPos,
                line: startPosDetails.line,
                column: startPosDetails.column
            },
            end: {
                offset: endPos,
                line: endPosDetails.line,
                column: endPosDetails.column
            }
        };
    }
    function peg$fail(expected) {
        if (peg$currPos < peg$maxFailPos) return;
        if (peg$currPos > peg$maxFailPos) {
            peg$maxFailPos = peg$currPos;
            peg$maxFailExpected = [];
        }
        peg$maxFailExpected.push(expected);
    }
    function peg$buildSimpleError(message, location) {
        return new $bb73f18d00d8f5c5$var$peg$SyntaxError(message, null, null, location);
    }
    function peg$buildStructuredError(expected, found, location) {
        return new $bb73f18d00d8f5c5$var$peg$SyntaxError($bb73f18d00d8f5c5$var$peg$SyntaxError.buildMessage(expected, found), expected, found, location);
    }
    function peg$parseExpression() {
        var s0, s1, s2, s3;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parse_();
        if (s1 !== peg$FAILED) {
            s2 = peg$parseEquationsAndInequalities();
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c1(s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c0);
        }
        return s0;
    }
    function peg$parseEquationsAndInequalities() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        s1 = peg$parseAdditionAndSubtraction();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$currPos;
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 61) {
                    s5 = peg$c2;
                    peg$currPos++;
                } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c3);
                }
                if (s5 === peg$FAILED) {
                    s5 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 92) {
                        s6 = peg$c4;
                        peg$currPos++;
                    } else {
                        s6 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c5);
                    }
                    if (s6 !== peg$FAILED) {
                        s7 = peg$parseTexOperatorsTitles();
                        if (s7 !== peg$FAILED) {
                            peg$savedPos = s5;
                            s6 = peg$c6(s1, s7);
                            s5 = s6;
                        } else {
                            peg$currPos = s5;
                            s5 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s5;
                        s5 = peg$FAILED;
                    }
                }
                if (s5 !== peg$FAILED) {
                    s6 = peg$parse_();
                    if (s6 !== peg$FAILED) {
                        s7 = peg$parseAdditionAndSubtraction();
                        if (s7 !== peg$FAILED) {
                            s4 = [
                                s4,
                                s5,
                                s6,
                                s7
                            ];
                            s3 = s4;
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$currPos;
                s4 = peg$parse_();
                if (s4 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 61) {
                        s5 = peg$c2;
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c3);
                    }
                    if (s5 === peg$FAILED) {
                        s5 = peg$currPos;
                        if (input.charCodeAt(peg$currPos) === 92) {
                            s6 = peg$c4;
                            peg$currPos++;
                        } else {
                            s6 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c5);
                        }
                        if (s6 !== peg$FAILED) {
                            s7 = peg$parseTexOperatorsTitles();
                            if (s7 !== peg$FAILED) {
                                peg$savedPos = s5;
                                s6 = peg$c6(s1, s7);
                                s5 = s6;
                            } else {
                                peg$currPos = s5;
                                s5 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s5;
                            s5 = peg$FAILED;
                        }
                    }
                    if (s5 !== peg$FAILED) {
                        s6 = peg$parse_();
                        if (s6 !== peg$FAILED) {
                            s7 = peg$parseAdditionAndSubtraction();
                            if (s7 !== peg$FAILED) {
                                s4 = [
                                    s4,
                                    s5,
                                    s6,
                                    s7
                                ];
                                s3 = s4;
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c7(s1, s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseTexOperatorsTitles() {
        var s0, s1, s2;
        s0 = peg$currPos;
        s1 = peg$parseWord();
        if (s1 !== peg$FAILED) {
            peg$savedPos = peg$currPos;
            s2 = peg$c8(s1);
            if (s2) s2 = void 0;
            else s2 = peg$FAILED;
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c9(s1);
                s0 = s1;
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseTexPrefixOperatorsTitles() {
        var s0, s1, s2;
        s0 = peg$currPos;
        s1 = peg$parseWord();
        if (s1 !== peg$FAILED) {
            peg$savedPos = peg$currPos;
            s2 = peg$c10(s1);
            if (s2) s2 = void 0;
            else s2 = peg$FAILED;
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c9(s1);
                s0 = s1;
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseAdditionAndSubtraction() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        s1 = peg$parseMultiplicationAndDivision();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$currPos;
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 43) {
                    s5 = peg$c11;
                    peg$currPos++;
                } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c12);
                }
                if (s5 === peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 45) {
                        s5 = peg$c13;
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c14);
                    }
                }
                if (s5 !== peg$FAILED) {
                    s6 = peg$parse_();
                    if (s6 !== peg$FAILED) {
                        s7 = peg$parseMultiplicationAndDivision();
                        if (s7 !== peg$FAILED) {
                            s4 = [
                                s4,
                                s5,
                                s6,
                                s7
                            ];
                            s3 = s4;
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$currPos;
                s4 = peg$parse_();
                if (s4 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 43) {
                        s5 = peg$c11;
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c12);
                    }
                    if (s5 === peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 45) {
                            s5 = peg$c13;
                            peg$currPos++;
                        } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c14);
                        }
                    }
                    if (s5 !== peg$FAILED) {
                        s6 = peg$parse_();
                        if (s6 !== peg$FAILED) {
                            s7 = peg$parseMultiplicationAndDivision();
                            if (s7 !== peg$FAILED) {
                                s4 = [
                                    s4,
                                    s5,
                                    s6,
                                    s7
                                ];
                                s3 = s4;
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c7(s1, s2);
                s0 = s1;
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseMultiplicationAndDivision() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8;
        s0 = peg$currPos;
        s1 = peg$parseUnaryPrefixOperation();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$currPos;
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 42) {
                    s5 = peg$c15;
                    peg$currPos++;
                } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c16);
                }
                if (s5 === peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 47) {
                        s5 = peg$c17;
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c18);
                    }
                    if (s5 === peg$FAILED) {
                        s5 = peg$currPos;
                        if (input.substr(peg$currPos, 5) === peg$c19) {
                            s6 = peg$c19;
                            peg$currPos += 5;
                        } else {
                            s6 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c20);
                        }
                        if (s6 !== peg$FAILED) {
                            s7 = peg$currPos;
                            peg$silentFails++;
                            s8 = peg$parseLetter();
                            peg$silentFails--;
                            if (s8 === peg$FAILED) s7 = void 0;
                            else {
                                peg$currPos = s7;
                                s7 = peg$FAILED;
                            }
                            if (s7 !== peg$FAILED) {
                                peg$savedPos = s5;
                                s6 = peg$c21(s1);
                                s5 = s6;
                            } else {
                                peg$currPos = s5;
                                s5 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s5;
                            s5 = peg$FAILED;
                        }
                    }
                }
                if (s5 !== peg$FAILED) {
                    s6 = peg$parse_();
                    if (s6 !== peg$FAILED) {
                        s7 = peg$parseUnaryPrefixOperation();
                        if (s7 !== peg$FAILED) {
                            s4 = [
                                s4,
                                s5,
                                s6,
                                s7
                            ];
                            s3 = s4;
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$currPos;
                s4 = peg$parse_();
                if (s4 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 42) {
                        s5 = peg$c15;
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c16);
                    }
                    if (s5 === peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 47) {
                            s5 = peg$c17;
                            peg$currPos++;
                        } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c18);
                        }
                        if (s5 === peg$FAILED) {
                            s5 = peg$currPos;
                            if (input.substr(peg$currPos, 5) === peg$c19) {
                                s6 = peg$c19;
                                peg$currPos += 5;
                            } else {
                                s6 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c20);
                            }
                            if (s6 !== peg$FAILED) {
                                s7 = peg$currPos;
                                peg$silentFails++;
                                s8 = peg$parseLetter();
                                peg$silentFails--;
                                if (s8 === peg$FAILED) s7 = void 0;
                                else {
                                    peg$currPos = s7;
                                    s7 = peg$FAILED;
                                }
                                if (s7 !== peg$FAILED) {
                                    peg$savedPos = s5;
                                    s6 = peg$c21(s1);
                                    s5 = s6;
                                } else {
                                    peg$currPos = s5;
                                    s5 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s5;
                                s5 = peg$FAILED;
                            }
                        }
                    }
                    if (s5 !== peg$FAILED) {
                        s6 = peg$parse_();
                        if (s6 !== peg$FAILED) {
                            s7 = peg$parseUnaryPrefixOperation();
                            if (s7 !== peg$FAILED) {
                                s4 = [
                                    s4,
                                    s5,
                                    s6,
                                    s7
                                ];
                                s3 = s4;
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c7(s1, s2);
                s0 = s1;
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseUnaryPrefixOperation() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 45) {
            s1 = peg$c13;
            peg$currPos++;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c14);
        }
        if (s1 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 43) {
                s1 = peg$c11;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c12);
            }
            if (s1 === peg$FAILED) {
                s1 = peg$currPos;
                if (input.charCodeAt(peg$currPos) === 92) {
                    s2 = peg$c4;
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c5);
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parseTexPrefixOperatorsTitles();
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s1;
                        s2 = peg$c22(s3);
                        s1 = s2;
                    } else {
                        peg$currPos = s1;
                        s1 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s1;
                    s1 = peg$FAILED;
                }
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                s3 = peg$parseUnaryPrefixOperation();
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c23(s1, s3);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) s0 = peg$parseImplicitMultiplication();
        return s0;
    }
    function peg$parseImplicitMultiplication() {
        var s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        s1 = peg$parsePowerAndFactorial();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$currPos;
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
                s5 = peg$parsePowerAndFactorialWithoutNumber();
                if (s5 !== peg$FAILED) {
                    s4 = [
                        s4,
                        s5
                    ];
                    s3 = s4;
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$currPos;
                s4 = peg$parse_();
                if (s4 !== peg$FAILED) {
                    s5 = peg$parsePowerAndFactorialWithoutNumber();
                    if (s5 !== peg$FAILED) {
                        s4 = [
                            s4,
                            s5
                        ];
                        s3 = s4;
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s1, s2);
                s0 = s1;
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsePowerAndFactorial() {
        var s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        s1 = peg$parseFactor();
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                s3 = peg$parseSuperScript();
                if (s3 === peg$FAILED) s3 = null;
                if (s3 !== peg$FAILED) {
                    s4 = peg$parse_();
                    if (s4 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 33) {
                            s5 = peg$c25;
                            peg$currPos++;
                        } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c26);
                        }
                        if (s5 === peg$FAILED) s5 = null;
                        if (s5 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c27(s1, s3, s5);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsePowerAndFactorialWithoutNumber() {
        var s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        s1 = peg$parseFactorNotNumber();
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                s3 = peg$parseSuperScript();
                if (s3 === peg$FAILED) s3 = null;
                if (s3 !== peg$FAILED) {
                    s4 = peg$parse_();
                    if (s4 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 33) {
                            s5 = peg$c25;
                            peg$currPos++;
                        } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c26);
                        }
                        if (s5 === peg$FAILED) s5 = null;
                        if (s5 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c27(s1, s3, s5);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseFactor() {
        var s0;
        s0 = peg$parseFactorNotNumber();
        if (s0 === peg$FAILED) s0 = peg$parseNumber();
        return s0;
    }
    function peg$parseFactorNotNumber() {
        var s0;
        s0 = peg$parseMemberExpression();
        if (s0 === peg$FAILED) {
            s0 = peg$parseTupleOrExprOrParenOrIntervalOrSet();
            if (s0 === peg$FAILED) {
                s0 = peg$parseMatrix();
                if (s0 === peg$FAILED) {
                    s0 = peg$parseBlock_VBars();
                    if (s0 === peg$FAILED) s0 = peg$parseTexEntities();
                }
            }
        }
        return s0;
    }
    function peg$parseBlock_VBars() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 4) === peg$c28) {
            s1 = peg$c28;
            peg$currPos += 4;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c29);
        }
        if (s1 === peg$FAILED) {
            if (input.substr(peg$currPos, 4) === peg$c30) {
                s1 = peg$c30;
                peg$currPos += 4;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c31);
            }
            if (s1 === peg$FAILED) {
                if (input.substr(peg$currPos, 5) === peg$c32) {
                    s1 = peg$c32;
                    peg$currPos += 5;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c33);
                }
                if (s1 === peg$FAILED) {
                    if (input.substr(peg$currPos, 5) === peg$c34) {
                        s1 = peg$c34;
                        peg$currPos += 5;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c35);
                    }
                    if (s1 === peg$FAILED) {
                        if (input.substr(peg$currPos, 5) === peg$c36) {
                            s1 = peg$c36;
                            peg$currPos += 5;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c37);
                        }
                    }
                }
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 124) {
                    s3 = peg$c38;
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c39);
                }
                if (s3 !== peg$FAILED) {
                    s4 = peg$parseExpression();
                    if (s4 !== peg$FAILED) {
                        if (input.substr(peg$currPos, 4) === peg$c28) {
                            s5 = peg$c28;
                            peg$currPos += 4;
                        } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c29);
                        }
                        if (s5 === peg$FAILED) {
                            if (input.substr(peg$currPos, 4) === peg$c30) {
                                s5 = peg$c30;
                                peg$currPos += 4;
                            } else {
                                s5 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c31);
                            }
                            if (s5 === peg$FAILED) {
                                if (input.substr(peg$currPos, 5) === peg$c32) {
                                    s5 = peg$c32;
                                    peg$currPos += 5;
                                } else {
                                    s5 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c33);
                                }
                                if (s5 === peg$FAILED) {
                                    if (input.substr(peg$currPos, 5) === peg$c34) {
                                        s5 = peg$c34;
                                        peg$currPos += 5;
                                    } else {
                                        s5 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c35);
                                    }
                                    if (s5 === peg$FAILED) {
                                        if (input.substr(peg$currPos, 6) === peg$c40) {
                                            s5 = peg$c40;
                                            peg$currPos += 6;
                                        } else {
                                            s5 = peg$FAILED;
                                            if (peg$silentFails === 0) peg$fail(peg$c41);
                                        }
                                    }
                                }
                            }
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parse_();
                            if (s6 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 124) {
                                    s7 = peg$c38;
                                    peg$currPos++;
                                } else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c39);
                                }
                                if (s7 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c42(s4);
                                    s0 = s1;
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseFunctions() {
        var s0, s1;
        peg$silentFails++;
        s0 = peg$parseBuiltinFunctions();
        if (s0 === peg$FAILED) {
            s0 = peg$parseOperatorname();
            if (s0 === peg$FAILED) s0 = peg$parseFunction();
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c43);
        }
        return s0;
    }
    function peg$parseBuiltinFunctions() {
        var s0, s1, s2, s3, s4, s5, s6;
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 92) {
            s1 = peg$c4;
            peg$currPos++;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c5);
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parseBuiltinFuncsTitles();
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parseSuperScript();
                    if (s4 === peg$FAILED) s4 = null;
                    if (s4 !== peg$FAILED) {
                        s5 = peg$parse_();
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parseBuiltinFunctionsArgs();
                            if (s6 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c45(s2, s4, s6);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c44);
        }
        return s0;
    }
    function peg$parseBuiltinFuncsTitles() {
        var s0, s1, s2;
        s0 = peg$currPos;
        s1 = peg$parseWord();
        if (s1 !== peg$FAILED) {
            peg$savedPos = peg$currPos;
            s2 = peg$c46(s1);
            if (s2) s2 = void 0;
            else s2 = peg$FAILED;
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c47(s1);
                s0 = s1;
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseBuiltinFunctionsArgs() {
        var s0;
        s0 = peg$parseFunctionParentheses();
        if (s0 === peg$FAILED) s0 = peg$parseImplicitMultiplication();
        return s0;
    }
    function peg$parseOperatorname() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 13) === peg$c48) {
            s1 = peg$c48;
            peg$currPos += 13;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c49);
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            s3 = peg$parse_();
            if (s3 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 123) {
                    s4 = peg$c50;
                    peg$currPos++;
                } else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c51);
                }
                if (s4 !== peg$FAILED) {
                    s5 = peg$parse_();
                    if (s5 !== peg$FAILED) {
                        s6 = peg$parseName();
                        if (s6 === peg$FAILED) s6 = peg$parseSpecialSymbols();
                        if (s6 !== peg$FAILED) {
                            s7 = peg$parse_();
                            if (s7 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 125) {
                                    s8 = peg$c52;
                                    peg$currPos++;
                                } else {
                                    s8 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c53);
                                }
                                if (s8 !== peg$FAILED) {
                                    peg$savedPos = s2;
                                    s3 = peg$c22(s6);
                                    s2 = s3;
                                } else {
                                    peg$currPos = s2;
                                    s2 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s2;
                                s2 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
            if (s2 === peg$FAILED) {
                s2 = peg$currPos;
                s3 = [];
                s4 = peg$parseWhitespace();
                if (s4 !== peg$FAILED) while(s4 !== peg$FAILED){
                    s3.push(s4);
                    s4 = peg$parseWhitespace();
                }
                else s3 = peg$FAILED;
                if (s3 !== peg$FAILED) {
                    s4 = peg$parseName();
                    if (s4 === peg$FAILED) s4 = peg$parseSpecialSymbols();
                    if (s4 !== peg$FAILED) {
                        peg$savedPos = s2;
                        s3 = peg$c22(s4);
                        s2 = s3;
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parseFunctionParentheses();
                    if (s4 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c54(s2, s4);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseFunction() {
        var s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = peg$parseName();
        if (s2 !== peg$FAILED) s1 = input.substring(s1, peg$currPos);
        else s1 = s2;
        if (s1 !== peg$FAILED) {
            peg$savedPos = peg$currPos;
            s2 = peg$c55(s1);
            if (s2) s2 = void 0;
            else s2 = peg$FAILED;
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parseFunctionParentheses();
                    if (s4 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c56(s1, s4);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseFunctionParentheses() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8;
        s0 = peg$currPos;
        peg$savedPos = peg$currPos;
        s1 = peg$c57();
        if (s1) s1 = void 0;
        else s1 = peg$FAILED;
        if (s1 !== peg$FAILED) {
            if (input.substr(peg$currPos, 4) === peg$c28) {
                s2 = peg$c28;
                peg$currPos += 4;
            } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c29);
            }
            if (s2 === peg$FAILED) {
                if (input.substr(peg$currPos, 4) === peg$c30) {
                    s2 = peg$c30;
                    peg$currPos += 4;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c31);
                }
                if (s2 === peg$FAILED) {
                    if (input.substr(peg$currPos, 5) === peg$c32) {
                        s2 = peg$c32;
                        peg$currPos += 5;
                    } else {
                        s2 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c33);
                    }
                    if (s2 === peg$FAILED) {
                        if (input.substr(peg$currPos, 5) === peg$c34) {
                            s2 = peg$c34;
                            peg$currPos += 5;
                        } else {
                            s2 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c35);
                        }
                        if (s2 === peg$FAILED) {
                            if (input.substr(peg$currPos, 5) === peg$c36) {
                                s2 = peg$c36;
                                peg$currPos += 5;
                            } else {
                                s2 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c37);
                            }
                        }
                    }
                }
            }
            if (s2 === peg$FAILED) s2 = null;
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (s3 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 40) {
                        s4 = peg$c58;
                        peg$currPos++;
                    } else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c59);
                    }
                    if (s4 !== peg$FAILED) {
                        s5 = peg$parseCommaExpression();
                        if (s5 !== peg$FAILED) {
                            if (input.substr(peg$currPos, 4) === peg$c28) {
                                s6 = peg$c28;
                                peg$currPos += 4;
                            } else {
                                s6 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c29);
                            }
                            if (s6 === peg$FAILED) {
                                if (input.substr(peg$currPos, 4) === peg$c30) {
                                    s6 = peg$c30;
                                    peg$currPos += 4;
                                } else {
                                    s6 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c31);
                                }
                                if (s6 === peg$FAILED) {
                                    if (input.substr(peg$currPos, 5) === peg$c32) {
                                        s6 = peg$c32;
                                        peg$currPos += 5;
                                    } else {
                                        s6 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c33);
                                    }
                                    if (s6 === peg$FAILED) {
                                        if (input.substr(peg$currPos, 5) === peg$c34) {
                                            s6 = peg$c34;
                                            peg$currPos += 5;
                                        } else {
                                            s6 = peg$FAILED;
                                            if (peg$silentFails === 0) peg$fail(peg$c35);
                                        }
                                        if (s6 === peg$FAILED) {
                                            if (input.substr(peg$currPos, 6) === peg$c40) {
                                                s6 = peg$c40;
                                                peg$currPos += 6;
                                            } else {
                                                s6 = peg$FAILED;
                                                if (peg$silentFails === 0) peg$fail(peg$c41);
                                            }
                                        }
                                    }
                                }
                            }
                            if (s6 === peg$FAILED) s6 = null;
                            if (s6 !== peg$FAILED) {
                                s7 = peg$parse_();
                                if (s7 !== peg$FAILED) {
                                    if (input.charCodeAt(peg$currPos) === 41) {
                                        s8 = peg$c60;
                                        peg$currPos++;
                                    } else {
                                        s8 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c61);
                                    }
                                    if (s8 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c62(s5);
                                        s0 = s1;
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            peg$savedPos = peg$currPos;
            s1 = peg$c63();
            if (s1) s1 = void 0;
            else s1 = peg$FAILED;
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 40) {
                    s2 = peg$c58;
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c59);
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parse_();
                    if (s3 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 41) {
                            s4 = peg$c60;
                            peg$currPos++;
                        } else {
                            s4 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c61);
                        }
                        if (s4 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c64();
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        return s0;
    }
    function peg$parseCommaExpression() {
        var s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        s1 = peg$parseExpression();
        if (s1 === peg$FAILED) s1 = peg$parseCommaExpressionEllipsis();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 44) {
                s4 = peg$c65;
                peg$currPos++;
            } else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c66);
            }
            if (s4 !== peg$FAILED) {
                s5 = peg$parseExpression();
                if (s5 === peg$FAILED) s5 = peg$parseCommaExpressionEllipsis();
                if (s5 !== peg$FAILED) {
                    peg$savedPos = s3;
                    s4 = peg$c6(s1, s5);
                    s3 = s4;
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$currPos;
                if (input.charCodeAt(peg$currPos) === 44) {
                    s4 = peg$c65;
                    peg$currPos++;
                } else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c66);
                }
                if (s4 !== peg$FAILED) {
                    s5 = peg$parseExpression();
                    if (s5 === peg$FAILED) s5 = peg$parseCommaExpressionEllipsis();
                    if (s5 !== peg$FAILED) {
                        peg$savedPos = s3;
                        s4 = peg$c6(s1, s5);
                        s3 = s4;
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c67(s1, s2);
                s0 = s1;
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseEllipsis() {
        var s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        s1 = peg$parse_();
        if (s1 !== peg$FAILED) {
            if (input.substr(peg$currPos, 3) === peg$c68) {
                s2 = peg$c68;
                peg$currPos += 3;
            } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c69);
            }
            if (s2 === peg$FAILED) {
                s2 = peg$currPos;
                if (input.charCodeAt(peg$currPos) === 92) {
                    s3 = peg$c4;
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c5);
                }
                if (s3 !== peg$FAILED) {
                    s4 = peg$parseDotsRule();
                    if (s4 !== peg$FAILED) {
                        peg$savedPos = s2;
                        s3 = peg$c70(s4);
                        s2 = s3;
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c71(s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseHorizontalEllipsis() {
        var s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        s1 = peg$parse_();
        if (s1 !== peg$FAILED) {
            if (input.substr(peg$currPos, 3) === peg$c68) {
                s2 = peg$c68;
                peg$currPos += 3;
            } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c69);
            }
            if (s2 === peg$FAILED) {
                s2 = peg$currPos;
                if (input.charCodeAt(peg$currPos) === 92) {
                    s3 = peg$c4;
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c5);
                }
                if (s3 !== peg$FAILED) {
                    if (input.substr(peg$currPos, 4) === peg$c72) {
                        s4 = peg$c72;
                        peg$currPos += 4;
                    } else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c73);
                    }
                    if (s4 === peg$FAILED) {
                        if (input.substr(peg$currPos, 5) === peg$c74) {
                            s4 = peg$c74;
                            peg$currPos += 5;
                        } else {
                            s4 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c75);
                        }
                    }
                    if (s4 !== peg$FAILED) {
                        peg$savedPos = s2;
                        s3 = peg$c70(s4);
                        s2 = s3;
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c71(s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseDotsRule() {
        var s0;
        if (input.substr(peg$currPos, 4) === peg$c72) {
            s0 = peg$c72;
            peg$currPos += 4;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c73);
        }
        if (s0 === peg$FAILED) {
            if (input.substr(peg$currPos, 5) === peg$c76) {
                s0 = peg$c76;
                peg$currPos += 5;
            } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c77);
            }
            if (s0 === peg$FAILED) {
                if (input.substr(peg$currPos, 5) === peg$c78) {
                    s0 = peg$c78;
                    peg$currPos += 5;
                } else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c79);
                }
                if (s0 === peg$FAILED) {
                    if (input.substr(peg$currPos, 5) === peg$c74) {
                        s0 = peg$c74;
                        peg$currPos += 5;
                    } else {
                        s0 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c75);
                    }
                }
            }
        }
        return s0;
    }
    function peg$parseCommaExpressionEllipsis() {
        var s0, s1;
        s0 = peg$currPos;
        s1 = peg$parseEllipsis();
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c80(s1);
        }
        s0 = s1;
        return s0;
    }
    function peg$parseTupleOrExprOrParenOrIntervalOrSet() {
        var s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        s1 = peg$parseBlockOpenings();
        if (s1 !== peg$FAILED) {
            peg$savedPos = peg$currPos;
            s2 = peg$c81(s1);
            if (s2) s2 = void 0;
            else s2 = peg$FAILED;
            if (s2 !== peg$FAILED) {
                s3 = peg$parseCommaExpression();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parseBlockClosings();
                    if (s4 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c82(s1, s3, s4);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            peg$savedPos = peg$currPos;
            s1 = peg$c83();
            if (s1) s1 = void 0;
            else s1 = peg$FAILED;
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 97) {
                    s2 = peg$c84;
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c85);
                }
                if (s2 !== peg$FAILED) {
                    s1 = [
                        s1,
                        s2
                    ];
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        return s0;
    }
    function peg$parseBlockOpenings() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$parseleftPrefixes();
        if (s1 === peg$FAILED) s1 = null;
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 40) {
                    s3 = peg$c58;
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c59);
                }
                if (s3 === peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 91) {
                        s3 = peg$c86;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c87);
                    }
                    if (s3 === peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 123) {
                            s3 = peg$c50;
                            peg$currPos++;
                        } else {
                            s3 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c51);
                        }
                        if (s3 === peg$FAILED) {
                            if (input.substr(peg$currPos, 3) === peg$c88) {
                                s3 = peg$c88;
                                peg$currPos += 3;
                            } else {
                                s3 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c89);
                            }
                            if (s3 === peg$FAILED) {
                                if (input.substr(peg$currPos, 2) === peg$c90) {
                                    s3 = peg$c90;
                                    peg$currPos += 2;
                                } else {
                                    s3 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c91);
                                }
                            }
                        }
                    }
                }
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c92(s3);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseBlockClosings() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$parserightPrefixes();
        if (s1 === peg$FAILED) s1 = null;
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 41) {
                    s3 = peg$c60;
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c61);
                }
                if (s3 === peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 93) {
                        s3 = peg$c93;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c94);
                    }
                    if (s3 === peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 125) {
                            s3 = peg$c52;
                            peg$currPos++;
                        } else {
                            s3 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c53);
                        }
                        if (s3 === peg$FAILED) {
                            if (input.substr(peg$currPos, 3) === peg$c95) {
                                s3 = peg$c95;
                                peg$currPos += 3;
                            } else {
                                s3 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c96);
                            }
                            if (s3 === peg$FAILED) {
                                if (input.substr(peg$currPos, 2) === peg$c97) {
                                    s3 = peg$c97;
                                    peg$currPos += 2;
                                } else {
                                    s3 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c98);
                                }
                            }
                        }
                    }
                }
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c92(s3);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseTexEntities() {
        var s0;
        s0 = peg$parseSpecialTexRules();
        if (s0 === peg$FAILED) s0 = peg$parseSpecialSymbols();
        return s0;
    }
    function peg$parseSpecialSymbols() {
        var s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 92) {
            s1 = peg$c4;
            peg$currPos++;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c5);
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parseSpecialSymbolsTitles();
            if (s2 !== peg$FAILED) {
                s3 = peg$currPos;
                peg$silentFails++;
                s4 = peg$parseLetter();
                peg$silentFails--;
                if (s4 === peg$FAILED) s3 = void 0;
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c99(s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseSpecialSymbolsTitles() {
        var s0, s1, s2, s3, s4, s5, s6;
        s0 = peg$currPos;
        s1 = peg$currPos;
        peg$silentFails++;
        s2 = peg$currPos;
        s3 = peg$parseTexOperatorsTitles();
        if (s3 !== peg$FAILED) {
            s4 = peg$currPos;
            peg$silentFails++;
            s5 = peg$parseLetter();
            peg$silentFails--;
            if (s5 === peg$FAILED) s4 = void 0;
            else {
                peg$currPos = s4;
                s4 = peg$FAILED;
            }
            if (s4 !== peg$FAILED) {
                s3 = [
                    s3,
                    s4
                ];
                s2 = s3;
            } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
        } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
        }
        peg$silentFails--;
        if (s2 === peg$FAILED) s1 = void 0;
        else {
            peg$currPos = s1;
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            peg$silentFails++;
            s3 = peg$currPos;
            s4 = peg$parseleftPrefixes();
            if (s4 !== peg$FAILED) {
                s5 = peg$currPos;
                peg$silentFails++;
                s6 = peg$parseLetter();
                peg$silentFails--;
                if (s6 === peg$FAILED) s5 = void 0;
                else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                }
                if (s5 !== peg$FAILED) {
                    s4 = [
                        s4,
                        s5
                    ];
                    s3 = s4;
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            peg$silentFails--;
            if (s3 === peg$FAILED) s2 = void 0;
            else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parseWord();
                if (s3 !== peg$FAILED) {
                    peg$savedPos = peg$currPos;
                    s4 = peg$c100(s3);
                    if (s4) s4 = void 0;
                    else s4 = peg$FAILED;
                    if (s4 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c101(s3);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseSpecialTexRules() {
        var s0;
        s0 = peg$parseSqrt();
        if (s0 === peg$FAILED) {
            s0 = peg$parseIntSumProd();
            if (s0 === peg$FAILED) s0 = peg$parseFrac();
        }
        return s0;
    }
    function peg$parseSqrt() {
        var s0, s1, s2, s3, s4, s5, s6;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 5) === peg$c102) {
            s1 = peg$c102;
            peg$currPos += 5;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c103);
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            peg$silentFails++;
            s3 = peg$parseLetter();
            peg$silentFails--;
            if (s3 === peg$FAILED) s2 = void 0;
            else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parseSquareBrackets();
                    if (s4 === peg$FAILED) s4 = null;
                    if (s4 !== peg$FAILED) {
                        s5 = peg$parse_();
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parseArg();
                            if (s6 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c104(s4, s6);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseIntSumProd() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 92) {
            s1 = peg$c4;
            peg$currPos++;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c5);
        }
        if (s1 !== peg$FAILED) {
            if (input.substr(peg$currPos, 3) === peg$c105) {
                s2 = peg$c105;
                peg$currPos += 3;
            } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c106);
            }
            if (s2 === peg$FAILED) {
                if (input.substr(peg$currPos, 3) === peg$c107) {
                    s2 = peg$c107;
                    peg$currPos += 3;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c108);
                }
                if (s2 === peg$FAILED) {
                    if (input.substr(peg$currPos, 4) === peg$c109) {
                        s2 = peg$c109;
                        peg$currPos += 4;
                    } else {
                        s2 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c110);
                    }
                }
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$currPos;
                peg$silentFails++;
                s4 = peg$parseLetter();
                peg$silentFails--;
                if (s4 === peg$FAILED) s3 = void 0;
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
                if (s3 !== peg$FAILED) {
                    s4 = peg$parse_();
                    if (s4 !== peg$FAILED) {
                        s5 = peg$currPos;
                        s6 = peg$currPos;
                        peg$silentFails++;
                        s7 = peg$currPos;
                        s8 = peg$parse_();
                        if (s8 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 95) {
                                s9 = peg$c111;
                                peg$currPos++;
                            } else {
                                s9 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c112);
                            }
                            if (s9 !== peg$FAILED) {
                                s8 = [
                                    s8,
                                    s9
                                ];
                                s7 = s8;
                            } else {
                                peg$currPos = s7;
                                s7 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s7;
                            s7 = peg$FAILED;
                        }
                        peg$silentFails--;
                        if (s7 !== peg$FAILED) {
                            peg$currPos = s6;
                            s6 = void 0;
                        } else s6 = peg$FAILED;
                        if (s6 !== peg$FAILED) {
                            s7 = peg$parseSubScript();
                            if (s7 === peg$FAILED) s7 = null;
                            if (s7 !== peg$FAILED) {
                                s8 = peg$parse_();
                                if (s8 !== peg$FAILED) {
                                    s9 = peg$parseSuperScript();
                                    if (s9 === peg$FAILED) s9 = null;
                                    if (s9 !== peg$FAILED) {
                                        peg$savedPos = s5;
                                        s6 = peg$c113(s2, s7, s9);
                                        s5 = s6;
                                    } else {
                                        peg$currPos = s5;
                                        s5 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s5;
                                    s5 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s5;
                                s5 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s5;
                            s5 = peg$FAILED;
                        }
                        if (s5 === peg$FAILED) {
                            s5 = peg$currPos;
                            s6 = peg$parseSuperScript();
                            if (s6 === peg$FAILED) s6 = null;
                            if (s6 !== peg$FAILED) {
                                s7 = peg$parse_();
                                if (s7 !== peg$FAILED) {
                                    s8 = peg$parseSubScript();
                                    if (s8 === peg$FAILED) s8 = null;
                                    if (s8 !== peg$FAILED) {
                                        peg$savedPos = s5;
                                        s6 = peg$c114(s2, s6, s8);
                                        s5 = s6;
                                    } else {
                                        peg$currPos = s5;
                                        s5 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s5;
                                    s5 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s5;
                                s5 = peg$FAILED;
                            }
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parse_();
                            if (s6 !== peg$FAILED) {
                                s7 = peg$parseEquationsAndInequalities();
                                if (s7 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c115(s2, s5, s7);
                                    s0 = s1;
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseFrac() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 5) === peg$c116) {
            s1 = peg$c116;
            peg$currPos += 5;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c117);
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            peg$silentFails++;
            s3 = peg$parseLetter();
            peg$silentFails--;
            if (s3 === peg$FAILED) s2 = void 0;
            else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (s3 !== peg$FAILED) {
                    s4 = peg$currPos;
                    s5 = peg$parseArg();
                    if (s5 !== peg$FAILED) {
                        s6 = peg$parse_();
                        if (s6 !== peg$FAILED) {
                            s7 = peg$parseArg();
                            if (s7 !== peg$FAILED) {
                                peg$savedPos = s4;
                                s5 = peg$c118(s5, s7);
                                s4 = s5;
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s4;
                        s4 = peg$FAILED;
                    }
                    if (s4 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c119(s4);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseOneCharArg() {
        var s0, s1;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parseAlphanumeric();
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c121();
        }
        s0 = s1;
        if (s0 === peg$FAILED) s0 = peg$parseSpecialSymbols();
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c120);
        }
        return s0;
    }
    function peg$parseMatrix() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 6) === peg$c122) {
            s1 = peg$c122;
            peg$currPos += 6;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c123);
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 123) {
                    s3 = peg$c50;
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c51);
                }
                if (s3 !== peg$FAILED) {
                    s4 = peg$parse_();
                    if (s4 !== peg$FAILED) {
                        s5 = peg$parseWord();
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parse_();
                            if (s6 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 125) {
                                    s7 = peg$c52;
                                    peg$currPos++;
                                } else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c53);
                                }
                                if (s7 !== peg$FAILED) {
                                    s8 = peg$parse_();
                                    if (s8 !== peg$FAILED) {
                                        s9 = peg$parseMatrixRows();
                                        if (s9 !== peg$FAILED) {
                                            s10 = peg$parse_();
                                            if (s10 !== peg$FAILED) {
                                                if (input.substr(peg$currPos, 4) === peg$c124) {
                                                    s11 = peg$c124;
                                                    peg$currPos += 4;
                                                } else {
                                                    s11 = peg$FAILED;
                                                    if (peg$silentFails === 0) peg$fail(peg$c125);
                                                }
                                                if (s11 !== peg$FAILED) {
                                                    s12 = peg$parse_();
                                                    if (s12 !== peg$FAILED) {
                                                        if (input.charCodeAt(peg$currPos) === 123) {
                                                            s13 = peg$c50;
                                                            peg$currPos++;
                                                        } else {
                                                            s13 = peg$FAILED;
                                                            if (peg$silentFails === 0) peg$fail(peg$c51);
                                                        }
                                                        if (s13 !== peg$FAILED) {
                                                            s14 = peg$parseWord();
                                                            if (s14 !== peg$FAILED) {
                                                                if (input.charCodeAt(peg$currPos) === 125) {
                                                                    s15 = peg$c52;
                                                                    peg$currPos++;
                                                                } else {
                                                                    s15 = peg$FAILED;
                                                                    if (peg$silentFails === 0) peg$fail(peg$c53);
                                                                }
                                                                if (s15 !== peg$FAILED) {
                                                                    peg$savedPos = s0;
                                                                    s1 = peg$c126(s5, s9, s14);
                                                                    s0 = s1;
                                                                } else {
                                                                    peg$currPos = s0;
                                                                    s0 = peg$FAILED;
                                                                }
                                                            } else {
                                                                peg$currPos = s0;
                                                                s0 = peg$FAILED;
                                                            }
                                                        } else {
                                                            peg$currPos = s0;
                                                            s0 = peg$FAILED;
                                                        }
                                                    } else {
                                                        peg$currPos = s0;
                                                        s0 = peg$FAILED;
                                                    }
                                                } else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                }
                                            } else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                            }
                                        } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseMatrixRows() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        s1 = peg$parseMatrixRow();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$currPos;
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
                if (input.substr(peg$currPos, 2) === peg$c127) {
                    s5 = peg$c127;
                    peg$currPos += 2;
                } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c128);
                }
                if (s5 !== peg$FAILED) {
                    s6 = peg$parse_();
                    if (s6 !== peg$FAILED) {
                        s7 = peg$parseMatrixRow();
                        if (s7 !== peg$FAILED) {
                            s4 = [
                                s4,
                                s5,
                                s6,
                                s7
                            ];
                            s3 = s4;
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$currPos;
                s4 = peg$parse_();
                if (s4 !== peg$FAILED) {
                    if (input.substr(peg$currPos, 2) === peg$c127) {
                        s5 = peg$c127;
                        peg$currPos += 2;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c128);
                    }
                    if (s5 !== peg$FAILED) {
                        s6 = peg$parse_();
                        if (s6 !== peg$FAILED) {
                            s7 = peg$parseMatrixRow();
                            if (s7 !== peg$FAILED) {
                                s4 = [
                                    s4,
                                    s5,
                                    s6,
                                    s7
                                ];
                                s3 = s4;
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c129(s1, s2);
                s0 = s1;
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseMatrixRow() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        s1 = peg$parseEquationsAndInequalities();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$currPos;
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 38) {
                    s5 = peg$c130;
                    peg$currPos++;
                } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c131);
                }
                if (s5 !== peg$FAILED) {
                    s6 = peg$parse_();
                    if (s6 !== peg$FAILED) {
                        s7 = peg$parseEquationsAndInequalities();
                        if (s7 !== peg$FAILED) {
                            s4 = [
                                s4,
                                s5,
                                s6,
                                s7
                            ];
                            s3 = s4;
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$currPos;
                s4 = peg$parse_();
                if (s4 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 38) {
                        s5 = peg$c130;
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c131);
                    }
                    if (s5 !== peg$FAILED) {
                        s6 = peg$parse_();
                        if (s6 !== peg$FAILED) {
                            s7 = peg$parseEquationsAndInequalities();
                            if (s7 !== peg$FAILED) {
                                s4 = [
                                    s4,
                                    s5,
                                    s6,
                                    s7
                                ];
                                s3 = s4;
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c129(s1, s2);
                s0 = s1;
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseMemberExpression() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        s1 = peg$parseMemberArg();
        if (s1 === peg$FAILED) s1 = peg$parseTupleOrExprOrParenOrIntervalOrSet();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$currPos;
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 46) {
                    s5 = peg$c132;
                    peg$currPos++;
                } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c133);
                }
                if (s5 !== peg$FAILED) {
                    s6 = peg$parse_();
                    if (s6 !== peg$FAILED) {
                        s7 = peg$parseMemberArg();
                        if (s7 !== peg$FAILED) {
                            s4 = [
                                s4,
                                s5,
                                s6,
                                s7
                            ];
                            s3 = s4;
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$currPos;
                s4 = peg$parse_();
                if (s4 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 46) {
                        s5 = peg$c132;
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c133);
                    }
                    if (s5 !== peg$FAILED) {
                        s6 = peg$parse_();
                        if (s6 !== peg$FAILED) {
                            s7 = peg$parseMemberArg();
                            if (s7 !== peg$FAILED) {
                                s4 = [
                                    s4,
                                    s5,
                                    s6,
                                    s7
                                ];
                                s3 = s4;
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c134(s1, s2);
                s0 = s1;
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseMemberArg() {
        var s0;
        s0 = peg$parseFunctions();
        if (s0 === peg$FAILED) s0 = peg$parseName();
        return s0;
    }
    function peg$parseName() {
        var s0, s1, s2;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parseLetter();
        if (s1 !== peg$FAILED) {
            s2 = peg$parseSubName();
            if (s2 === peg$FAILED) s2 = null;
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c136(s1, s2);
                s0 = s1;
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c135);
        }
        return s0;
    }
    function peg$parseSubName() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8;
        s0 = peg$currPos;
        s1 = peg$parse_();
        if (s1 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 95) {
                s2 = peg$c111;
                peg$currPos++;
            } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c112);
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parseAlphanumeric();
                    if (s4 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c137(s4);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parse_();
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 95) {
                    s2 = peg$c111;
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c112);
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parse_();
                    if (s3 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 123) {
                            s4 = peg$c50;
                            peg$currPos++;
                        } else {
                            s4 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c51);
                        }
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parse_();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parseName();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parse_();
                                    if (s7 !== peg$FAILED) {
                                        if (input.charCodeAt(peg$currPos) === 125) {
                                            s8 = peg$c52;
                                            peg$currPos++;
                                        } else {
                                            s8 = peg$FAILED;
                                            if (peg$silentFails === 0) peg$fail(peg$c53);
                                        }
                                        if (s8 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s1 = peg$c138(s6);
                                            s0 = s1;
                                        } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        return s0;
    }
    function peg$parseAlphanumeric() {
        var s0, s1;
        peg$silentFails++;
        if (peg$c140.test(input.charAt(peg$currPos))) {
            s0 = input.charAt(peg$currPos);
            peg$currPos++;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c141);
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c139);
        }
        return s0;
    }
    function peg$parseLetter() {
        var s0, s1;
        peg$silentFails++;
        if (peg$c143.test(input.charAt(peg$currPos))) {
            s0 = input.charAt(peg$currPos);
            peg$currPos++;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c144);
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c142);
        }
        return s0;
    }
    function peg$parseWord() {
        var s0, s1, s2;
        s0 = peg$currPos;
        s1 = [];
        if (peg$c143.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
        } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c144);
        }
        if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
            s1.push(s2);
            if (peg$c143.test(input.charAt(peg$currPos))) {
                s2 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c144);
            }
        }
        else s1 = peg$FAILED;
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c145();
        }
        s0 = s1;
        return s0;
    }
    function peg$parseNumber() {
        var s0, s1, s2, s3, s4;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parseSign();
        if (s1 === peg$FAILED) s1 = null;
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                s3 = peg$currPos;
                s4 = peg$parseSimpleNumber();
                if (s4 !== peg$FAILED) s3 = input.substring(s3, peg$currPos);
                else s3 = s4;
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c147(s1);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c146);
        }
        return s0;
    }
    function peg$parseSimpleNumber() {
        var s0, s1, s2, s3;
        peg$silentFails++;
        s0 = peg$currPos;
        if (peg$c148.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c149);
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            if (peg$c148.test(input.charAt(peg$currPos))) {
                s3 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c149);
            }
            if (s3 === peg$FAILED) s3 = peg$parseWhitespace();
            while(s3 !== peg$FAILED){
                s2.push(s3);
                if (peg$c148.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c149);
                }
                if (s3 === peg$FAILED) s3 = peg$parseWhitespace();
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parseDecimalPart();
                if (s3 === peg$FAILED) s3 = null;
                if (s3 !== peg$FAILED) {
                    s1 = [
                        s1,
                        s2,
                        s3
                    ];
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) s0 = peg$parseDecimalPart();
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c146);
        }
        return s0;
    }
    function peg$parseDecimalPart() {
        var s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 46) {
            s1 = peg$c132;
            peg$currPos++;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c133);
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                if (peg$c148.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c149);
                }
                if (s3 !== peg$FAILED) {
                    s4 = [];
                    if (peg$c148.test(input.charAt(peg$currPos))) {
                        s5 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c149);
                    }
                    if (s5 === peg$FAILED) s5 = peg$parseWhitespace();
                    while(s5 !== peg$FAILED){
                        s4.push(s5);
                        if (peg$c148.test(input.charAt(peg$currPos))) {
                            s5 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c149);
                        }
                        if (s5 === peg$FAILED) s5 = peg$parseWhitespace();
                    }
                    if (s4 !== peg$FAILED) {
                        s1 = [
                            s1,
                            s2,
                            s3,
                            s4
                        ];
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseSign() {
        var s0;
        if (input.charCodeAt(peg$currPos) === 45) {
            s0 = peg$c13;
            peg$currPos++;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c14);
        }
        if (s0 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 43) {
                s0 = peg$c11;
                peg$currPos++;
            } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c12);
            }
        }
        return s0;
    }
    function peg$parseSquareBrackets() {
        var s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 91) {
            s1 = peg$c86;
            peg$currPos++;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c87);
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                s3 = peg$parseEquationsAndInequalities();
                if (s3 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 93) {
                        s4 = peg$c93;
                        peg$currPos++;
                    } else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c94);
                    }
                    if (s4 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c1(s3);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseCurlyBrackets() {
        var s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 123) {
            s1 = peg$c50;
            peg$currPos++;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c51);
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                s3 = peg$parseEquationsAndInequalities();
                if (s3 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                        s4 = peg$c52;
                        peg$currPos++;
                    } else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c53);
                    }
                    if (s4 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c1(s3);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseSuperScript() {
        var s0, s1, s2, s3;
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 94) {
            s1 = peg$c151;
            peg$currPos++;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c152);
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                s3 = peg$parseArg();
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c153(s3);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c150);
        }
        return s0;
    }
    function peg$parseSubScript() {
        var s0, s1, s2, s3;
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 95) {
            s1 = peg$c111;
            peg$currPos++;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c112);
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                s3 = peg$parseArg();
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c153(s3);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c154);
        }
        return s0;
    }
    function peg$parseArg() {
        var s0, s1;
        peg$silentFails++;
        s0 = peg$parseCurlyBrackets();
        if (s0 === peg$FAILED) {
            s0 = peg$parseFrac();
            if (s0 === peg$FAILED) {
                s0 = peg$parseSpecialSymbols();
                if (s0 === peg$FAILED) s0 = peg$parseOneCharArg();
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c155);
        }
        return s0;
    }
    function peg$parseleftPrefixes() {
        var s0;
        if (input.substr(peg$currPos, 5) === peg$c36) {
            s0 = peg$c36;
            peg$currPos += 5;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c37);
        }
        if (s0 === peg$FAILED) {
            if (input.substr(peg$currPos, 4) === peg$c30) {
                s0 = peg$c30;
                peg$currPos += 4;
            } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c31);
            }
            if (s0 === peg$FAILED) {
                if (input.substr(peg$currPos, 5) === peg$c34) {
                    s0 = peg$c34;
                    peg$currPos += 5;
                } else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c35);
                }
                if (s0 === peg$FAILED) {
                    if (input.substr(peg$currPos, 4) === peg$c28) {
                        s0 = peg$c28;
                        peg$currPos += 4;
                    } else {
                        s0 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c29);
                    }
                    if (s0 === peg$FAILED) {
                        if (input.substr(peg$currPos, 5) === peg$c32) {
                            s0 = peg$c32;
                            peg$currPos += 5;
                        } else {
                            s0 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c33);
                        }
                    }
                }
            }
        }
        return s0;
    }
    function peg$parserightPrefixes() {
        var s0;
        if (input.substr(peg$currPos, 6) === peg$c40) {
            s0 = peg$c40;
            peg$currPos += 6;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c41);
        }
        if (s0 === peg$FAILED) {
            if (input.substr(peg$currPos, 4) === peg$c30) {
                s0 = peg$c30;
                peg$currPos += 4;
            } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c31);
            }
            if (s0 === peg$FAILED) {
                if (input.substr(peg$currPos, 5) === peg$c34) {
                    s0 = peg$c34;
                    peg$currPos += 5;
                } else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c35);
                }
                if (s0 === peg$FAILED) {
                    if (input.substr(peg$currPos, 4) === peg$c28) {
                        s0 = peg$c28;
                        peg$currPos += 4;
                    } else {
                        s0 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c29);
                    }
                    if (s0 === peg$FAILED) {
                        if (input.substr(peg$currPos, 5) === peg$c32) {
                            s0 = peg$c32;
                            peg$currPos += 5;
                        } else {
                            s0 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c33);
                        }
                    }
                }
            }
        }
        return s0;
    }
    function peg$parseNewline() {
        var s0, s1;
        peg$silentFails++;
        if (input.charCodeAt(peg$currPos) === 10) {
            s0 = peg$c157;
            peg$currPos++;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c158);
        }
        if (s0 === peg$FAILED) {
            if (input.substr(peg$currPos, 2) === peg$c159) {
                s0 = peg$c159;
                peg$currPos += 2;
            } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c160);
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c156);
        }
        return s0;
    }
    function peg$parseSpace() {
        var s0, s1;
        peg$silentFails++;
        if (input.charCodeAt(peg$currPos) === 32) {
            s0 = peg$c162;
            peg$currPos++;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c163);
        }
        if (s0 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 9) {
                s0 = peg$c164;
                peg$currPos++;
            } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c165);
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c161);
        }
        return s0;
    }
    function peg$parseEscapedSpace() {
        var s0;
        if (input.substr(peg$currPos, 2) === peg$c166) {
            s0 = peg$c166;
            peg$currPos += 2;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c167);
        }
        return s0;
    }
    function peg$parseWhitespace() {
        var s0, s1;
        peg$silentFails++;
        s0 = peg$parseNewline();
        if (s0 === peg$FAILED) {
            s0 = peg$parseSpace();
            if (s0 === peg$FAILED) s0 = peg$parseEscapedSpace();
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c168);
        }
        return s0;
    }
    function peg$parse_() {
        var s0, s1;
        peg$silentFails++;
        s0 = [];
        s1 = peg$parseWhitespace();
        while(s1 !== peg$FAILED){
            s0.push(s1);
            s1 = peg$parseWhitespace();
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$c169);
        }
        return s0;
    }
    {
        let defaultLetters = [
            "alpha",
            "Alpha",
            "beta",
            "Beta",
            "gamma",
            "Gamma",
            "pi",
            "Pi",
            "varpi",
            "phi",
            "Phi",
            "varphi",
            "mu",
            "theta",
            "vartheta",
            "epsilon",
            "varepsilon",
            "upsilon",
            "Upsilon",
            "zeta",
            "eta",
            "Lambda",
            "lambda",
            "kappa",
            "omega",
            "Omega",
            "psi",
            "Psi",
            "chi",
            "tau",
            "sigma",
            "Sigma",
            "varsigma",
            "rho",
            "varrho",
            "Xi",
            "xi",
            "nu",
            "imath",
            "jmath",
            "ell",
            "Re",
            "Im",
            "wp",
            "Nabla",
            "infty",
            "aleph",
            "beth",
            "gimel",
            "comicron",
            "iota",
            "delta",
            "thetasym",
            "omicron",
            "Delta",
            "Epsilon",
            "Zeta",
            "Eta",
            "Theta",
            "Iota",
            "Kappa",
            "Mu",
            "Nu",
            "Omicron",
            "Rho",
            "Tau",
            "Chi",
            "infty",
            "infin",
            "nabla",
            "mho",
            "mathsterling",
            "surd",
            "diamonds",
            "Diamond",
            "hearts",
            "heartsuit",
            "spades",
            "spadesuit",
            "clubsuit",
            "clubs",
            "bigstar",
            "star",
            "blacklozenge",
            "lozenge",
            "sharp",
            "maltese",
            "blacksquare",
            "square",
            "triangle",
            "blacktriangle"
        ];
        // default builtin functions
        let defaultBIFs = [
            "sinh",
            "cosh",
            "tanh",
            "sin",
            "cos",
            "tan",
            "sec",
            "csc",
            "cot",
            "arcsin",
            "arccos",
            "arctan",
            "arcsec",
            "arccsc",
            "arccot",
            "ln"
        ];
        // don't import defaults from a module, because we should clone it deeply
        // so let's create new defaults object every time parse is invoked
        let defaultOptions = {
            // singleCharName: true, // obselete
            /* operatorNames: // this is for something like this: \operatorname{floor} */ /*   [ */ /*     "floor", "ceil", "round", "random", "factorial", */ /*     "sech", "csch", "coth", "abs", "arsinh", "arcosh", */ /*     "artanh", "arasinh", "aracosh", "aratanh", */ /*   ], */ autoMult: true,
            functions: [],
            keepParentheses: false,
            builtinLetters: defaultLetters,
            builtinFunctions: defaultBIFs,
            extra: {
                memberExpressions: true,
                sets: true,
                matrices: true,
                tuples: true,
                intervals: true,
                ellipsis: {
                    funcArgs: true,
                    sets: true,
                    matrices: true,
                    tuples: true,
                    infixOperators: true
                }
            }
        };
        options = $hGGZK(defaultOptions, options); /// override the default options
        if (options.builtinFunctions[0] === '...') // replace the three dots with the default things.
        options.builtinFunctions.splice(0, 1, ...defaultBIFs);
        if (options.builtinLetters[0] === '...') // replace the three dots with the default things.
        options.builtinLetters.splice(0, 1, ...defaultLetters);
    }
    let rawInput = input, // does commaExpression contains ellipsis
    // it has to be LIFO stack, push and pop
    doesContainEllipsis = [];
    // they are static, shouldn't be controlled by options
    let texOperators1 = [
        "neq",
        "approx",
        "eqsim",
        "simeq",
        "ge",
        "geq",
        "geqq",
        "geqslant",
        "gg",
        "ggg",
        "gggtr",
        "le",
        "leq",
        "leqq",
        "leqslant",
        "ll",
        "lll",
        "llless",
        "notin",
        "ni",
        "in",
        "isin"
    ];
    let texPrefixOperators1 = [
        "pm",
        "mp",
        "neg",
        "lnot"
    ];
    /* .forEach(n=> console.log(`    <tr>\n      <td><code>\\${n}</code></td>\n    </tr>`)) */ text = function() {
        return rawInput.substring(peg$savedPos, peg$currPos);
    };
    input = $4ntVg(input, peg$computeLocation, error);
    function createNode(...args) {
        let n = new $ab1nR(...args);
        let ellipsis = options.extra.ellipsis;
        let __doesContainEllipsis = doesContainEllipsis.length && doesContainEllipsis.pop();
        if (!options.autoMult && n.type === "automult") error('invalid syntax, hint: missing * sign');
        if (n.type === "member expression" && !options.extra.memberExpressions) error(`tuples syntax is not allowed`);
        if (n.type === "tuple") {
            if (!options.extra.tuples) error('tuples syntax is not allowed');
            let ellipsisAllowed = typeof ellipsis === 'object' ? ellipsis.tuples : ellipsis;
            if (__doesContainEllipsis && !ellipsisAllowed) error('ellipsis is not allowed to be in tuples');
        }
        if (n.type === "set") {
            if (!options.extra.sets) error('sets syntax is not allowed');
            let ellipsisAllowed = typeof ellipsis === 'object' ? ellipsis.sets : ellipsis;
            if (__doesContainEllipsis && !ellipsisAllowed) error('ellipsis is not allowed to be in sets');
        }
        if (n.type === "matrix") {
            if (!options.extra.matrices) error('matrices syntax is not allowed');
            let ellipsisAllowed = typeof ellipsis === 'object' ? ellipsis.matrices : ellipsis;
            if (__doesContainEllipsis && !ellipsisAllowed) error('ellipsis is not allowed to be in matrices');
        }
        if (n.type === "interval") {
            if (!options.extra.intervals) error('intervals syntax is not allowed');
            let ellipsisAllowed = typeof ellipsis === 'object' ? ellipsis.intervals : ellipsis;
            if (__doesContainEllipsis && !ellipsisAllowed) error('ellipsis is not allowed to be in intervals');
        }
        n.match = {
            location: location(),
            text: text()
        };
        return n;
    }
    function check(value, rule) {
        if (rule instanceof Array) for(let i = 0; i < rule.length; i++){
            if (check(value, rule[i])) return true;
        }
        else if (rule instanceof Function) return rule(value);
        else if (rule instanceof RegExp) return rule.test(value);
        else return value === rule;
    }
    function handleBlock(node, o, c) {
        // node is expr or 1d array or 2d array
        // validation, [), (], {}, [], () are allowed
        if (o === '{' && c !== "}" || o !== '{' && c === "}") error(`unexpected brackets: "${o} and "${c}"`);
        // now node is 1d array or expr
        // sets
        if (o === "{") // set with one item
        return createNode("set", Array.isArray(node) ? node : [
            node
        ]);
        // tuple or interval or set
        if (Array.isArray(node)) {
            if (node.length === 2 && options.extra.intervals) {
                // make sure not have ellpsis
                if (node[0].type !== "ellipsis" && node[1].type !== "ellipsis") return createNode("interval", node, {
                    startInclusive: o === "[",
                    endInclusive: c === "]"
                });
            }
            if (o === "[" || c === "]") // all possible expressions for "[]" are consumed here
            error(`unexpected brackets: "${o} and "${c}"`);
            if (node.length === 2 && !options.extra.tuples) // we may not throw here, it will throw inside createNode
            // but this message is more informative
            return error("neither tuples nor intervals are allowed");
            return createNode("tuple", node);
        }
        // -----------| now node is expr |-----------
        // all possible expressions for "[]" are consumed here
        // extra validation, we are now dealing with "()"
        if (o === "[" || c === "]") error(`unexpected brackets: "${o} and "${c}"`);
        return options.keepParentheses ? createNode("parentheses", [
            node
        ]) : node;
    }
    peg$result = peg$startRuleFunction();
    if (peg$result !== peg$FAILED && peg$currPos === input.length) return peg$result;
    else {
        if (peg$result !== peg$FAILED && peg$currPos < input.length) peg$fail(peg$endExpectation());
        throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
    }
}
module.exports = {
    SyntaxError: $bb73f18d00d8f5c5$var$peg$SyntaxError,
    parse: $bb73f18d00d8f5c5$var$peg$parse,
    version: $fHenM,
    Node: $ab1nR
};

});
parcelRegister("ab1nR", function(module, exports) {
class $768c0145017a1fef$var$Node {
    constructor(type, args, props){
        Object.assign(this, props);
        if ($768c0145017a1fef$var$Node.types.values.indexOf(type) === -1) throw new Error('invalid type for the node, "' + type + '"');
        else if ([
            "operatorname",
            "function"
        ].indexOf(type) > -1) {
            if (!args || !Array.isArray(args)) throw new Error('invalid args for the node, "' + type + '"');
        } else if (type === "operator") {
            if (!props.operatorType) throw new Error(`operator should have operatorType as well.`);
            if (props.operatorType !== "infix" && props.operatorType !== "postfix" && props.operatorType !== "prefix") throw new Error(`invalid operatorType: ${props.operatorType}`);
            if ($768c0145017a1fef$var$Node.types.operators[props.operatorType].indexOf(props.name) === -1) throw new Error(`invalid operator name: ${props.name}`);
        }
        this.type = type;
        this.args = args;
    }
    checkType(t) {
        if ($768c0145017a1fef$var$Node.types.values.indexOf(t) > -1) return this.type === t;
        else throw new Error("invalid type, can't check for \"" + t + '"');
    }
    /**
   * check every property except args
   */ check(props, checkArgs = false) {
        for(let p in props){
            if (p === "type") {
                if (!this.checkType(props.type)) return false;
            } else if (checkArgs || p !== "args") {
                if (Array.isArray(props[p])) {
                    if (!Array.isArray(props[p])) return false;
                    else if (props[p].length !== this[p].length) return false;
                    if (!this.check.bind(this[p])(props[p])) return false;
                } else if (this[p] instanceof $768c0145017a1fef$var$Node) {
                    if (!this[p].check(props[p])) return false;
                } else if (props[p] !== this[p]) return false;
            }
        }
        return true;
    }
    /**
   * Check if this node or any descendant matches the given props
   * @param props properties to check nodes against
   * @param checkArgs whether to also check args property
   * @returns {boolean} true if this node or any descendant matches
   */ contains(props, checkArgs = false) {
        if (this.check(props, checkArgs)) return true;
        if (this.args) {
            for (let arg of this.args)if (arg.contains(props, checkArgs)) return true;
        }
        return false;
    }
}
$768c0145017a1fef$var$Node.types = {
    NUMBER: 'number',
    ID: 'id',
    FUNCTION: 'function',
    MEMBER_EXPRESSION: 'member expression',
    OPERATOR: 'operator',
    AUTO_MULT: 'automult',
    BLOCK: 'block',
    FRAC: 'frac',
    PROD: 'prod',
    INT: 'int',
    SUM: 'sum',
    SQRT: 'sqrt',
    OPERATORNAME: 'operatorname',
    PARENTHESES: "parentheses",
    INTERVAL: "interval",
    MATRIX: "matrix",
    TUPLE: "tuple",
    SET: "set",
    ABS: "abs",
    ELLIPSIS: "ellipsis"
};
$768c0145017a1fef$var$Node.types.values = Object.values($768c0145017a1fef$var$Node.types);
$768c0145017a1fef$var$Node.types.operators = {
    infix: [
        "^",
        "*",
        "/",
        "+",
        "-",
        "=",
        "cdot"
    ],
    postfix: [
        "!"
    ],
    prefix: [
        "-",
        "+",
        "pm",
        "mp",
        "neg",
        "lnot"
    ]
};
$768c0145017a1fef$var$Node.types.blocks = [
    '()',
    '{}',
    '[]',
    '()',
    '{}',
    '[]',
    '||'
];
module.exports = $768c0145017a1fef$var$Node;

});

parcelRegister("fHenM", function(module, exports) {
// this file is auto generated
// the current version is:
module.exports = "3.0.3";

});

parcelRegister("4ntVg", function(module, exports) {
// TODO: unmatched brackets are valid incase of intervals
/**
 * the main purpose of this function is to remove some brace "{}" that has np effect on the parse process
 */ module.exports = function prepareInput(input, peg$computeLocation, error) {
    // #region vars
    let ignore = /^(?:\s|\\ )+/;
    // when we remove the {...} block after one of these,
    // the parsing expression will result in wrong tree
    let needsArgRegExp = /^(\^|_|\\frac|\\sqrt)/;
    let defaultState = {
        neededArgsCount: 0,
        argsFor: "",
        prefix: ""
    };
    let state = Object.assign({}, defaultState);
    // it is used when we already consumed to stop he auto increament i.value++
    let skipConsuming = false;
    let i = {};
    let blockStack = [];
    let blocks = [
        {
            opening: "{",
            closing: "}",
            prefixed: true
        },
        {
            opening: "(",
            closing: ")",
            prefixed: true
        },
        {
            opening: "[",
            closing: "]",
            prefixed: true
        },
        {
            opening: "|",
            closing: "|",
            prefixed: true
        },
        {
            opening: "\\{{",
            closing: "\\}}"
        },
        {
            opening: "\\{",
            closing: "\\}"
        },
        {
            opening: "\\|",
            closing: "\\|"
        }
    ];
    let blockPrefixesReg = /^(\\operatorname|\\left|\\right|\\begin|\\end|\\bigg|\\Bigg|\\big|\\Big)/;
    // #endregion
    function closeBLock(b) {
        let last = blockStack.pop();
        // on some cases like: 1+2 \\sqrt{\\farc{1}}
        if (state.neededArgsCount) {
            let location = peg$computeLocation(i.value, i.value);
            error(`${state.argsFor} needs ${state.neededArgsCount === 1 ? "an argument" : state.neededArgsCount + " argumets"}`, location);
        }
        // -------------------
        //      CASE 1
        // -------------------
        if (last.state.prefix === "\\begin") {
            let braces = input.slice(last.i, i.value + 1);
            blockStack.push({
                isBegin: true,
                i: i.value,
                // for throwing when \end is not found 
                b: {
                    opening: "\\begin" + braces,
                    closing: "\\end" + braces
                }
            });
            Object.assign(state, defaultState);
            i.value += b.closing.length; // consume the closing char
            return;
        } else if (last.state.prefix === "\\end") {
            if (state.prefix) {
                let location = peg$computeLocation(last.value, last.value);
                error(`\\end found but can't find \\begin`, location);
            }
            let begin = blockStack.pop(); // pop another block
            // we expect to find the one we push earlier
            if (!begin.isBegin) {
                let location = peg$computeLocation(last.value, last.value);
                error(`\\end found but can't find \\begin`, location);
            }
            Object.assign(state, defaultState);
            i.value += b.closing.length; // consume the closing char
            return;
        // new we habe begin-end block
        }
        // -------------------
        //      CASE 2
        // -------------------
        if (last.state.prefix === "\\operatorname") {
            // just end here
            Object.assign(state, defaultState);
            i.value += b.closing.length; // consume the closing char
            return;
        }
        // -------------------
        //      CASE 3
        // -------------------
        let msg;
        // un matched prefixes, `\\left {  \\right}`
        if (state.prefix && !b.prefixed) msg = `unexpected "${b.closing}" after "${state.prefix}"`;
        else if (last.state.prefix === "\\left") {
            if (state.prefix !== "\\right") {
                msg = `expected "\\right"${state.prefix ? ` but "${state.prefix}" found` : ""}`;
                let location = peg$computeLocation(i.value, i.value);
                error(msg, location);
            }
            Object.assign(state, defaultState);
            i.value += b.closing.length; // consume the closing char
            return;
        } else if (state.prefix !== last.state.prefix) msg = `expected "${last.state.prefix}"${state.prefix ? ` but "${state.prefix}" found` : ""}`;
        else if (state.prefix) {
            Object.assign(state, defaultState);
            i.value += b.closing.length; // consume the closing char
            return;
        }
        if (msg) {
            let location = peg$computeLocation(i.value, i.value);
            error(msg, location);
        }
        // -------------------
        //      CASE 4
        // -------------------
        // we are exiting to the parent block
        // we have to restore defaults
        Object.assign(state, defaultState);
        if (last.b.opening === "{") {
            /// it has effect with frac sqrt ^ _
            if (!last.state.neededArgsCount) // handling the unimportant braces or throw error if
            // contains some invalid expression
            input = input.slice(0, last.i) + " " + input.slice(last.i + 1, i.value) + " " + input.slice(i.value + 1);
            else if (last.state.neededArgsCount === 2 && last.state.argsFor === "\\frac") {
                // upate the current state
                state.argsFor = "\\frac";
                state.neededArgsCount = 1;
            }
        } else if (last.b.opening === "[") {
            if (last.state.neededArgsCount && last.state.argsFor === "\\sqrt") {
                // upate the current state
                state.argsFor = "\\sqrt";
                state.neededArgsCount = 1;
            }
        }
        i.value += b.closing.length; // consume the closing char
    }
    function openBLock(b) {
        let msg;
        // validations
        if (state.prefix === "\\right") msg = `unexpected \\right at the block opening "${b.opening}"`;
        else if (b.opening !== "{" && (state.prefix === "\\begin" || state.prefix === "\\end" || state.prefix === "\\operatorname")) // such as: `\\begin [something] asd \\end [something]`
        msg = `expected block "{ ... }" but ${b.opening} found`;
        else if (state.prefix && !b.prefixed) msg = `unexpected "${b.closing}" after "${state.prefix}"`;
        if (msg) {
            let location = peg$computeLocation(i.value, i.value);
            error(msg, location);
        }
        // push to the block stack, clone the state
        blockStack.push({
            b: b,
            i: i.value,
            state: Object.assign({}, state)
        });
        Object.assign(state, defaultState); // restore defaults
        i.value += b.opening.length; // consume the closing char
    }
    Object.defineProperty(i, "value", {
        get () {
            return this.__value;
        },
        set (v) {
            input.slice(v, -1).replace(ignore, (m)=>{
                v += m.length; // consume ignored letters, such as white spaces
            });
            this.__value = v;
            // stop consuming at the end of the for loop
            // if we are changing i.value nomally, it won't effect any thing
            // skipConsuming is set to false then for loop `continue;`
            skipConsuming = true;
        }
    });
    i.value = 0;
    while(i.value < input.length){
        // validation and determine the current state
        if (state.prefix === "\\operatorname") {
            if (!/^([a-z]|\\[a-z])/i.test(input.slice(i.value))) {
                const location = peg$computeLocation(i.value, i.value);
                error(`unexpected "${state.prefix}" before "${input[i.value]}"`, location);
            }
            state.prefix = "";
        } else if (state.prefix) {
            const location = peg$computeLocation(i.value, i.value);
            error(`unexpected "${state.prefix}" before "${input[i.value]}"`, location);
        }
        input.slice(i.value).replace(needsArgRegExp, (m)=>{
            // tex = "\\frac\\sqrt{1}{2}!"; in such a tex input, there would be error, but
            // tex = "\\sqrt\\frac{1}{2}!"; will still the same and will be parsed
            // tex = "\\sqrt\\frac{1}_{2}!";
            // tex = "\\sqrt\\frac{1}^{2}!";
            // tex = "a_a_1"; is NOT valid
            // tex = "a_{a_1}"; is VALID
            // in the previous last two cases, an error must be thrown
            let a = state.neededArgsCount === 2 ? "a" : "another"; // for semantic purpose
            let location;
            if (state.neededArgsCount && state.argsFor === "\\frac" && (m === "^" || m === "_") || state.neededArgsCount && state.argsFor === "\\frac" && m === "\\sqrt") location = peg$computeLocation(i.value, i.value);
            if (location) error(`expected ${a} group after \\frac, but found "${m}"`, location);
            state.neededArgsCount = m === "\\frac" ? 2 : 1;
            state.argsFor = m;
            i.value += m.length; // consume the matched text
        });
        input.slice(i.value).replace(blockPrefixesReg, (pref)=>{
            state.prefix = pref;
            i.value += pref.length; // consume the matched text
        });
        // loop through the input, open and close blocks using hereinabove functions
        for (const b of blocks){
            let last;
            if (blockStack.length) last = blockStack[blockStack.length - 1];
            if (b.opening === b.closing) // this is true for opening and closing the block
            {
                if (input.slice(i.value, i.value + b.opening.length) === b.opening /* || b.closing */ ) {
                    if (last && last.b === b) closeBLock(b);
                    else openBLock(b);
                    break; // stop the blocks for-loop
                }
            } else if (input.slice(i.value, i.value + b.opening.length) === b.opening) {
                openBLock(b);
                break; // stop blocks the for-loop
            } else if (input.slice(i.value, i.value + b.closing.length) === b.closing) {
                if (last && last.b !== b) {
                    const location = peg$computeLocation(i.value, i.value);
                    error(`"${last.b.opening}" found but the block is not closed, hint: add "${last.b.closing}"`, location);
                } else if (!last || blockStack.filter((_)=>_.b === b).length === 0) {
                    const location = peg$computeLocation(i.value, i.value);
                    // closing with out opening
                    error(`block "${b.opening}" is not found before!`, location);
                }
                closeBLock(b);
                break; // stop the blocks for-loop
            }
        }
        if (state.prefix === "begin" || state.prefix === "end") {
            // such as: `\\begin 1 asd \\end 1`
            let location = peg$computeLocation(i.value, i.value);
            error(`expected block "{something}" but "${input[i.value]}" found`, location);
        }
        if (!skipConsuming) {
            i.value++;
            if (state.neededArgsCount) state.neededArgsCount--;
        }
        skipConsuming = false; // reset it
    }
    if (blockStack.length > 0) {
        let last = blockStack.pop();
        // this will throw reference error if the module used standalone
        const location = peg$computeLocation(i.value, i.value);
        // this will throw syntax error in the built commonjs module
        error(`"${last.b.opening}" found but the block is not closed, hint: add "${last.b.closing}"`, location);
    }
    return input;
};

});

parcelRegister("hGGZK", function(module, exports) {
/*
 * Recursively merge properties of two objects, but we want to create new object,
 * we don't want to mutate `obj1`
 */ module.exports = function mergeRecursive(obj1, obj2) {
    for(var p in obj2){
        let p1 = obj1[p], p2 = obj2[p];
        if (p1 && p1.constructor === Object && p2 && p2.constructor === Object) obj1[p] = mergeRecursive(p1, p2);
        else // we may use object.clone, but we won't mutate any value inside options
        obj1[p] = obj2[p];
    }
    return obj1;
};

});



window.mathLatexParser = (parcelRequire("g5O3G"));

})();
//# sourceMappingURL=browser-index.js.map
